import { Form } from 'formik';
import styled from 'styled-components';
import { accent, gray, primary, secondary, symbol, tertiary, white } from '~/components/mixins/color';

export const Container = styled.div`
  height: 100%;
  max-height: ${(props) => props.maxHeight};
  width: 100%;
  display: flex;
  flex-direction: row;
  padding: 10px;

  @media (max-width: 425px) {
    max-height: 100%;
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 185px);
`;

export const FormContainer = styled(Form)`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  width: 100%;
  padding: 10px;
  span {
    margin: 0 0 10px;
  }
`;

export const ImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 100%;
  padding: 10px;
  background: ${secondary.hex()};

  h4 {
    color: ${gray.hex()};
    font-weight: normal;
    margin-bottom: 10px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }
  img {
    max-width: 180px;
  }
`;

export const InputItem = styled.div`
  display: grid;
  position: relative;
  margin: 0 0 10px;
  width: 100%;

  & > svg {
    position: absolute;
    right: 15px;
    align-self: center;
    color: ${symbol.hex()};
    transition: color 0.2s ease 0s;
  }

  &:focus-within > input {
    border-color: ${accent.hex()};
  }

  &:focus-within > svg {
    color: ${accent.hex()};
  }

  input {
    background: ${primary.hex()};
    border: 2px solid ${tertiary.hex()};
    border-radius: 3px;
    padding: 22px 40px 8px 10px;
    color: ${white.hex()};
    position: relative;
    transition: border-color 0.2s ease-in 0s;

    &:focus + label,
    &:not([value='']) + label {
      font-size: 70%;
      transform: translate3d(0, -100%, 0);
      opacity: 1;
      top: 20px;
      color: ${white.hex()};
    }
    &:not([value='']) + label {
      color: ${gray.hex()};
    }
    &:focus + label {
      color: ${white.hex()};
    }
    &:focus::placeholder {
      color: ${white.hex()};
    }
    & + label {
      position: absolute;
      top: 15px;
      padding-left: 10px;
      transition: all 200ms;
      color: ${gray.hex()};
      opacity: 0.7;
    }
  }
`;

export const Item = styled.div`
  display: flex;
  justify-content: space-between;
  height: 50px;
  padding: 15px;
  background: ${primary.hex()};
  border: 2px solid ${tertiary.hex()};
  border-radius: 3px;
  color: ${white.hex()};

  &:hover {
    background-color: ${secondary.hex()};
  }

  & > svg {
    color: ${symbol.hex()};
    transition: color 0.2s ease 0s;

    &:hover {
      color: ${accent.hex()};
      cursor: pointer;
    }
  }

  & .column-data {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-right: 30px;

    .first {
      display: flex;
      flex-direction: column;
    }
  }
`;

export const HiddenInput = styled.input`
  width: 0;
  height: 0;
  display: none;
  visibility: 0;
  padding: 0;
  margin: 0;
`;
